export default "__VITE_ASSET__8b8070ff__"